import React, { useEffect, useState } from "react";
import { getAgents, getServers } from "../../redux/actions/serverActions";
import { useDispatch, useSelector } from "react-redux";

import Contacts from "./Contacts";
import Finess from "./Finess";
import Groups from "./Groups";
import Servers from "./Servers";
import PageEntete, { useUrlTab } from "../utils/PageEntete";
import { getAccess } from "../../redux/actions/accessActions";
import { getClients } from "../../redux/actions/clientActions";
import { getContacts } from "../../redux/actions/contactActions";
import { getGroups } from "../../redux/actions/groupActions";
import { getLicences } from "../../redux/actions/licenceActions";
import { getModules } from "../../redux/actions/moduleActions";
import { getUsers } from "../../redux/actions/userActions";
import { getVagues } from "../../redux/actions/vagueActions";

const VUES = [
  { key: "environments", label: "Environnements CTI", children: <Finess /> },
  { key: "servers", label: "Serveurs", children: <Servers /> },
  { key: "groups", label: "Groupes", children: <Groups /> },
  { key: "contacts", label: "Contacts", children: <Contacts /> },
];

function Clients() {
  const dispatch = useDispatch();
  const [vue, setVue] = useUrlTab(VUES.map((v) => v.key));
  // Une vue deja ouverte reste montee (masquee) : sa recherche et ses filtres sont
  // conserves au retour, comme avec les anciens onglets.
  const [ouvertes, setOuvertes] = useState([vue]);
  useEffect(() => {
    setOuvertes((prev) => (prev.includes(vue) ? prev : [...prev, vue]));
  }, [vue]);
  const contacts = useSelector((state) => state.contacts.contacts);

  useEffect(() => {
    dispatch(getServers());
    dispatch(getAgents());
    dispatch(getClients());
    dispatch(getVagues());
    dispatch(getGroups());
    dispatch(getLicences());
    dispatch(getModules());
    dispatch(getUsers());
    dispatch(getAccess());
  }, [dispatch]);

  useEffect(() => {
    if (!Object.values(contacts).length) {
      dispatch(getContacts());
    }
  });

  return (
    <div className="cti-page">
      <PageEntete title="Clients" label="Vue" items={VUES} value={vue} onChange={setVue} />
      <div className="cti-panel">
        {VUES.filter((v) => v.key === vue || ouvertes.includes(v.key)).map((v) => (
          <div
            key={v.key}
            role="tabpanel"
            aria-label={v.label}
            hidden={v.key !== vue}
          >
            {v.children}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Clients;
